import { Dayjs } from 'dayjs';

import { NumberFormatter, Week } from '@summit/models';

import { EboNameObject } from '../base-classes/ebo-name-object';
import { Company } from '../organization/company/company';
import { Contract } from '../organization/company/contract';
import { ServiceArea } from '../organization/service-area/service-area';
import { CompanySettlement } from './company-settlement';
import { SettlementSectionType } from './settlement-section-type.enum';

export class SettlementSection extends EboNameObject {
  companySettlementID: string;
  companySettlement: CompanySettlement;
  order: number;
  serviceAreaId: string;
  serviceArea: ServiceArea;
  type: SettlementSectionType;
  quantity: number;
  stops: number;
  total: number;

  constructor(jsonData: Partial<SettlementSection>) {
    super(jsonData);
    if (jsonData) {
      if (jsonData.companySettlement) {
        this.companySettlement = new CompanySettlement(jsonData.companySettlement);
      }
      if (jsonData.serviceArea) {
        this.serviceArea = new ServiceArea(jsonData.serviceArea);
      }
    }
  }
  get defaultSort(): string {
    return `${this.eventDate.format('YYYYMMDD')}-${this.internalCompany.name}-${NumberFormatter(this.order, 2)}`;
  }

  get eventDate(): Dayjs {
    return this.companySettlement.eventDate;
  }

  get internalCompany(): Company {
    return this.companySettlement.company;
  }

  get serviceAreaName(): string {
    return this.serviceArea ? this.serviceArea.toShortString() : 'Non-Service Area Related';
  }

  get externalCompany(): Company {
    return this.companySettlement?.externalCompany;
  }

  get contract(): Contract {
    return this.companySettlement?.contract;
  }

  get contractName(): string {
    return this.contract ? this.contract.name : '';
  }

  get weekNumber(): string {
    const tenantWeek = new Week(this.eventDate);
    return `Week #${NumberFormatter(tenantWeek.end.isoWeek(), 2)}`;
  }
  set weekNumber(value: string) {
    //NOP
  }

  get combinedContract(): string {
    return this.contract ? `${this.internalCompany?.name}: ${this.contract.name}` : '';
  }
}
